module.exports = __webpack_public_path__ + "f793e3d0.svg";